import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Container from "../components/Container";

function getYouTubeId(url = "") {
  return url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/)?.[1] || "";
}

export default function NewsArticle() {
  const { slug } = useParams();
  const [article, setArticle] = useState(undefined);

  useEffect(() => {
    fetch("/data/homepage.json").then((response) => response.json()).then((data) => {
      const news = (data.sections || []).find((section) => section.type === "news");
      setArticle((news?.items || []).find((item) => item.slug === slug) || null);
    }).catch(() => setArticle(null));
  }, [slug]);

  if (article === undefined) return <main className="min-h-[60vh] bg-[#faf9f6]" />;
  if (!article) return <main className="grid min-h-[60vh] place-items-center bg-[#faf9f6] p-6 text-center"><div><h1 className="text-3xl font-bold">الخبر غير موجود</h1><Link to="/news" className="mt-5 inline-block text-[#8d6b35]">العودة إلى جميع الأخبار</Link></div></main>;

  const videoId = getYouTubeId(article.youtubeUrl);
  return (
    <main className="bg-[#faf9f6]">
      <article className="py-12 sm:py-20">
        <Container>
          <div className="mx-auto max-w-4xl">
            <Link to="/news" className="text-sm font-bold text-[#8d6b35]">→ جميع الأخبار</Link>
            <div className="mt-8 border-b border-[#dcd7cd] pb-8">
              <div className="flex gap-3 text-sm font-bold text-[#9a763d]"><span>{article.mediaType === "video" ? "فيديو" : "ألبوم صور"}</span>{article.date && <time>{article.date}</time>}</div>
              <h1 className="mt-4 text-[38px] font-extrabold leading-[1.35] text-[#252923] sm:text-[54px]">{article.title}</h1>
              {article.summary && <p className="mt-5 text-lg leading-9 text-[#686b65]">{article.summary}</p>}
            </div>

            {videoId && <div className="mt-10 aspect-video overflow-hidden bg-black"><iframe className="h-full w-full" src={`https://www.youtube-nocookie.com/embed/${videoId}`} title={article.title} allowFullScreen /></div>}
            {!videoId && article.coverImage && <img src={article.coverImage} alt={article.imageAlt || article.title} className="mt-10 aspect-[16/9] w-full object-cover" />}

            {article.body && <div className="whitespace-pre-line py-10 text-[17px] leading-9 text-[#3f433e] sm:text-lg">{article.body}</div>}

            {article.photos?.length > 0 && <div className="grid gap-3 border-t border-[#dcd7cd] pt-10 sm:grid-cols-2">
              {article.photos.map((photo, index) => <img key={`${photo.image}-${index}`} src={photo.image} alt={photo.alt || ""} loading="lazy" className="aspect-[4/3] w-full object-cover" />)}
            </div>}
          </div>
        </Container>
      </article>
    </main>
  );
}
